import { AutogenLayoutRenditionFtpProfiles } from "./autogen/AutogenLayoutRenditionFtpProfiles";
import { ClickEvent, DropdownItem,  DataSourceExecutionEvent } from "@mcleod/components";

export class RenditionFtpProfiles extends AutogenLayoutRenditionFtpProfiles {

    override onLoad() {
        this.sourceDpsqlh.search();     //get all fields
        this.sourceCatxrefh.search();     //get all fields
        this.SetDropDowns();
    }

    SetDropDowns()
    {
        const items: DropdownItem[] = [];
        //items.push({ caption: "Yes", value: "Y" });
        //items.push({ caption: "No", value: "N" });
        items.push(new DropdownItem( "Y", "Yes" ));
        items.push(new DropdownItem( "N", "No" ));
        //Combine Folders
        this.textboxFtppCombine.items = items;
        //Color
        this.textboxFtppColor.items = items;
        //Export File
        this.textboxFtppFileexport.items = items;
        //Format
        const items2: DropdownItem[] = [];
        //items2.push({ caption: "Tif", value: "T" });
        //items2.push({ caption: "Pdf", value: "P" });
        items2.push(new DropdownItem( "T", "Tif" ));
        items2.push(new DropdownItem( "P", "Pdf" ));
        this.textboxFtppFormat.items = items2;
        //Export Resolution
        const items3: DropdownItem[] = [];
        //items3.push({ caption: "Folder", value: "F" });
        //items3.push({ caption: "Image", value: "I" });
        items3.push(new DropdownItem( "F", "Folder" ));
        items3.push(new DropdownItem( "I", "Image" ));
        this.textboxFtppExportres.items = items3;
        //Unit
        const items4: DropdownItem[] = [];
        //items4.push({ caption: "Single Folder", value: "S" });
        //items4.push({ caption: "Multiple Folders", value: "M" });
        //items4.push({ caption: "All Folders", value: "A" });
        items4.push(new DropdownItem( "S", "Single Folder" ));
        items4.push(new DropdownItem( "M", "Multiple Folders" ));
        items4.push(new DropdownItem( "A", "All Folders" ));
        this.textboxFtppUnit.items = items4;
        //Packing
        const items5: DropdownItem[] = [];
        //items5.push({ caption: "None", value: "N" });
        //items5.push({ caption: "Tar", value: "T" });
        //items5.push({ caption: "Zip", value: "Z" });
        items5.push(new DropdownItem( "N", "None" ));
        items5.push(new DropdownItem( "T", "Tar" ));
        items5.push(new DropdownItem( "Z", "Zip" ));
        this.textboxFtppPacking.items = items5;
    }


/** This is an event handler for the afterExecution event of sourceDpsqlh. */
  sourceDpsqlhAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.sqlh_desc, value: row._data.sqlh_grpid.toString() });
        items.push(new DropdownItem( row._data.sqlh_grpid.toString(), row._data.sqlh_desc ));
    }
    this.textboxFtppSqlgrpid.items = items;
  }

/** This is an event handler for the afterExecution event of sourceCatxrefh. */
  sourceCatxrefhAfterExecution(event: DataSourceExecutionEvent) {
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    for (const row of rows) {
        //console.log("Row: ", row );
        //items.push({ caption: row._data.catxh_desc, value: row._data.catxh_id.toString() });
        items.push(new DropdownItem( row._data.catxh_id.toString(), row._data.catxh_desc ));
    }
    this.textboxFtppCatxid.items = items;
  }
}
